import { render, staticRenderFns } from "./ztcPackage.vue?vue&type=template&id=2feee2a0&scoped=true&"
import script from "./ztcPackage.vue?vue&type=script&lang=js&"
export * from "./ztcPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feee2a0",
  null
  
)

export default component.exports